import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "checkbox"]
  static values = {
    documentId: Number,
    userId: Number,
    nodeUid: String
  }

  connect() {
    this.csrfToken = document.querySelector("meta[name='csrf-token']")?.content
  }

  handleKeydown(event) {
    // Support keyboard navigation (Space to toggle)
    if (event.key === ' ') {
      event.preventDefault()
      const checkbox = event.currentTarget.querySelector('.finding-checkbox')
      if (checkbox) {
        checkbox.checked = !checkbox.checked
        this.toggle({ target: checkbox })
      }
    }
  }

  toggle(event) {
    const checkbox = event.target
    const findingItem = checkbox.closest(".finding-item")
    const findingUid = findingItem.dataset.findingUid
    const isChecked = checkbox.checked

    // Update UI
    if (isChecked) {
      findingItem.classList.add("selected")
    } else {
      findingItem.classList.remove("selected")
    }

    // Update ARIA attribute
    findingItem.setAttribute('aria-checked', isChecked)

    // Save to backend
    this.saveFinding(findingUid, isChecked, findingItem)
  }

  saveFinding(findingUid, isSelected, findingItem) {
    const csrfToken = document.querySelector("[name='csrf-token']")?.content
    const findingText = findingItem.querySelector(".finding-text")?.textContent

    fetch(`/api/documents/${this.documentIdValue}/toggle_finding`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({
        user_id: this.userIdValue,
        finding_uid: findingUid,
        is_selected: isSelected,
        finding_text: findingText
      })
    })
      .then((response) => {
        if (response.ok) {
          // Dispatch event to update reasoning tool
          this.dispatch("findingToggled", {
            detail: {
              findingUid: findingUid,
              isSelected: isSelected,
              findingText: findingText
            }
          })
        } else {
          console.error("Failed to save finding")
          // Revert UI on error
          const checkbox = findingItem.querySelector(".finding-checkbox")
          if (checkbox) {
            checkbox.checked = !isSelected
            if (isSelected) {
              findingItem.classList.add("selected")
            } else {
              findingItem.classList.remove("selected")
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error saving finding:", error)
      })
  }
}
